<script>
    import { createEventDispatcher } from 'svelte';
    import { DialogOverlay, DialogContent } from 'svelte-accessible-dialog';
    import CloseButton from "./CloseButton.svelte";


    // Create an event dispatcher
    const dispatch = createEventDispatcher();

    export let isOpen = false;

    // Emit the "open" event when thumbnail is clicked
    function openVideo() {
    isOpen = true;
    dispatch('open');
    }

    // Close the modal-->
   function closeModal() {
    isOpen = false;
    }

    function DismissThis() {

        dispatch('dismiss');
        closeModal();

    }
</script>

<!-- Display the thumbnail -->
<div class="mb-4 p-0">
    <button class="p-0 m-0 transparent border-0"
            on:click={openVideo}>
    <img src="https://i3.ytimg.com/vi/DUPlZec6Gn4/maxresdefault.jpg" alt="Video Thumbnail"  />
    </button>
    <p class="small text-center w-100">What is a Library Database?</p>
</div>

<!-- Modal dialog to show the video -->
<DialogOverlay {isOpen} onDismiss="{DismissThis}">
    <DialogContent aria-label="Video">
        <div class="d-flex justify-content-end m-0 p-0 mb-2">
            <CloseButton on:click={closeModal}>Close</CloseButton>
        </div>

        <iframe
                src="https://player.vimeo.com/video/1123725445?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                title="What are library databases"
                width="100%"
                height="540">
        </iframe>

        <p class="mt-2 text-center">
            <a href="https://vimeo.com/1123725445"
               target="_blank"
               rel="noopener noreferrer"
               class="small">
                Watch "What are Library Databases" on Vimeo
            </a>
        </p>
    </DialogContent>
</DialogOverlay>
